const URL_API = process.env.REACT_APP_API_URL

export const PLACEMENT_URL = `${URL_API}/placement`
export const URL_DOWNLOAD_USER_DATA = (placementId) => `${URL_API}/download/users/csv/${placementId}`

export const inputData = [{
  id: 'placement',
  title: 'DOWNLOAD.PLACEMENT_PLACEHOLDER',
  type: 'select',
  iconName: 'placement',
  // options: [],
  // url: `${URL_API}/placement/`,
  // transform: options => options.map(opt => ({
  //   value: opt._id,
  //   label: opt.name,
  // })),
}]
